import lodashIsPlainObject from 'lodash/isPlainObject';
import {toV1, toV2} from './version-converters';
import {getSortName} from '../constants/issue-attribute-names';

export const decamelizeProperties = (sourceObject = {}, targetObject = {}) => {
  // eslint-disable-next-line no-return-assign
  Object.keys(sourceObject).forEach(prop => (targetObject[toV1(prop)] = sourceObject[prop]));
  return targetObject;
};

export const camelizeProperties = (sourceObject = {}, targetObject = {}) => {
  Object.keys(sourceObject).forEach(prop => {
    const value = sourceObject[prop];
    // eslint-disable-next-line no-return-assign
    return (targetObject[toV2(prop)] = lodashIsPlainObject(value) ? camelizeProperties(value) : value);
  });
  return targetObject;
};

const convertAttributesArray = (targetObject, arrayName, converter) => {
  const array = targetObject[arrayName];
  if (array && Array.isArray(array)) {
    // eslint-disable-next-line no-return-assign
    targetObject[arrayName] = array.map(converter);
  }
};
export const camelizeAttributesArray = (targetObject, arrayName) =>
  convertAttributesArray(targetObject, arrayName, toV2);
export const decamelizeAttributesArray = (targetObject, arrayName) =>
  convertAttributesArray(targetObject, arrayName, toV1);

export const isBadPermissionStatus = statusCode => {
  const status = parseInt(statusCode, 10);
  return status >= 400 && status < 500;
};

export const getSortValue = (value, map = {}, converter = undefined) => {
  const isDescending = value.startsWith('-');
  if (isDescending) {
    value = value.substring(1);
  }
  value = getSortName(value);
  if (converter) {
    value = converter(value);
  }
  value = map[value] ? map[value] : value;

  return isDescending ? `-${value}` : value;
};
